module.exports = __webpack_public_path__ + "img/liverpool.998b8cbb.png";